__turbopack_context__.v({
  "bottomLine": "TitleSection-module__aFhQDW__bottomLine",
  "header": "TitleSection-module__aFhQDW__header",
  "infoGraphic": "TitleSection-module__aFhQDW__infoGraphic",
  "infoGraphicContainer": "TitleSection-module__aFhQDW__infoGraphicContainer",
  "lightMode": "TitleSection-module__aFhQDW__lightMode",
  "mascot": "TitleSection-module__aFhQDW__mascot",
  "subtitle": "TitleSection-module__aFhQDW__subtitle",
  "title": "TitleSection-module__aFhQDW__title",
  "titleSectionContainer": "TitleSection-module__aFhQDW__titleSectionContainer",
});
